var map = {
	"./africanCapitals.json": [
		42,
		4
	],
	"./animauxScientifiques.json": [
		43,
		5
	],
	"./bolchevisme.json": [
		44,
		6
	],
	"./capboulangerieAccronymes.json": [
		45,
		7
	],
	"./capboulangerieElectrique.json": [
		46,
		8
	],
	"./capboulangerieOeuf.json": [
		47,
		9
	],
	"./capboulangeriePetrissage.json": [
		48,
		10
	],
	"./departements.json": [
		49,
		11
	],
	"./duo.json": [
		50,
		12
	],
	"./europeanCapitals.json": [
		51,
		13
	],
	"./frenchlesson.json": [
		52,
		14
	],
	"./leçonSloveneAvoir.json": [
		53,
		15
	],
	"./leçonSloveneBases.json": [
		54,
		16
	],
	"./leçonSloveneDay.json": [
		55,
		17
	],
	"./leçonSloveneDifficile.json": [
		56,
		18
	],
	"./leçonSloveneEtre.json": [
		57,
		19
	],
	"./leçonSloveneExpressions.json": [
		58,
		20
	],
	"./leçonSloveneFamille.json": [
		59,
		21
	],
	"./leçonSloveneFeed.json": [
		60,
		22
	],
	"./leçonSloveneIm.json": [
		61,
		23
	],
	"./leçonSloveneSentenceFeed.json": [
		62,
		24
	],
	"./leçonSloveneSentenceJournee.json": [
		63,
		25
	],
	"./mendeleiev.json": [
		64,
		26
	],
	"./monnaies.json": [
		65,
		27
	],
	"./planets.json": [
		66,
		28
	],
	"./pseudonymes.json": [
		67,
		29
	],
	"./test.json": [
		68,
		30
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 19;
module.exports = webpackAsyncContext;